import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import api from "../api/axiosInstance";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";

function UserEdit() {
  const [searchParams] = useSearchParams();
  const RequestId = searchParams.get("id");
  const [product, setProduct] = useState(null); // State to hold product data
  const [errorMessage, setErrorMessage] = useState(null); // State for error handling
  const navigate = useNavigate();
  useEffect(() => {
    if (RequestId) {
      fetchProductData(RequestId);
    }
  }, [RequestId]);

  const fetchProductData = (id) => {
    api
      .get('/request/frame/list', {
        params: { frame_id: id },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setProduct(res.data.result); // Set the fetched product data
        } else {
          setErrorMessage("Failed to fetch product data");
        }
      })
      .catch((err) => {
        console.error("Product fetch error:", err);
        setErrorMessage("Failed to fetch product data");
      });
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname === "/user_view") {
      console.log("Adding classes to the body.");
      document.body.classList.remove("login-page");
      document.body.classList.add("sidebar-mini");
    }
  }, []);

  const formatFileName = (fileName) => {
    const extension = fileName.split(".").pop();
    let baseName = fileName;

    if (fileName.length > 10) {
      baseName = fileName.substring(0, 6);
      return `${baseName}...${extension}`;
    } else {
      return fileName;
    }
  };

  const handleUpdateProduct = async (e) => {
    e.preventDefault();

    // Prepare payload
    const payload = {
      frame_id: RequestId,
      frame_type: product.request_type === "frame" ? product.frame_type : "",
      frame_size: product.request_type === "frame" ? product.frame_size : "",
      album_type: product.request_type === "album" ? product.album_type : "",
      album_size: product.request_type === "album" ? product.album_size : "",
      requeststatus: product.status,
      //   photo_list: product.photo_list,
    };

    try {
      const response = await api.post('/request/frame/update', payload);
      if (response.data.status === "success") {
        // Handle success
        console.log("Product updated successfully!");
        navigate("/users");
      } else {
        setErrorMessage("Failed to update product");
      }
    } catch (error) {
      console.error("Update product error:", error);
      setErrorMessage("Failed to update product");
    }
  };

  // Render loading or error message while fetching data
  if (!product && !errorMessage) {
    return <div>Loading...</div>;
  }

  // Render error message if fetch failed
  if (errorMessage) {
    return <div>{errorMessage}</div>;
  }

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  #{product._id} - {product.user_id.first_name}
                </h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <a href="/users">
                      <i className="fa-solid fa-arrow-left-long mr-2" />
                      Back
                    </a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}

        {/* Main content */}
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Id</label>
                          <div className="col-12 col-md-8">{product._id}</div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">User</label>
                          <div className="col-12 col-md-8">
                            {product.user_id.first_name}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Email</label>
                          <div className="col-12 col-md-8">
                            {product.user_id.email_address}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Phone</label>
                          <div className="col-12 col-md-8">
                            {product.user_id.phone_number}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Request for
                          </label>
                          <div className="col-12 col-md-8">
                            {product.request_type}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            No of Photos
                          </label>
                          <div className="col-12 col-md-8">
                            {product.photo_list.length}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Type</label>
                          <div className="col-12 col-md-8">
                            {product.request_type === "frame" && (
                              <select
                                className="form-control"
                                value={product.frame_type}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    frame_type: e.target.value,
                                  })
                                }
                              >
                                <option>--Select--</option>
                                <option value="Canvas Prints">
                                  Canvas Prints
                                </option>
                                <option value="Acrylic Photo Frame">
                                  Acrylic Photo Frame
                                </option>
                                <option value="Premium Photo with Frame">
                                  Premium Photo with Frame
                                </option>
                                <option value="Acrylic Photo Blocks">
                                  Acrylic Photo Blocks
                                </option>
                                <option value="Desk Calendar with Photo Frame">
                                  Desk Calendar with Photo Frame
                                </option>
                                <option value="LED Photo Frames">
                                  LED Photo Frames
                                </option>
                                <option value="LED Rotating Cube">
                                  LED Rotating Cube
                                </option>
                                <option value="Others">Others</option>
                                {/* Add other options here */}
                              </select>
                            )}
                            {product.request_type === "album" && (
                              <select
                                className="form-control"
                                value={product.album_type}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    album_type: e.target.value,
                                  })
                                }
                              >
                                <option>--Select--</option>
                                <option value="Softcover Photobook Album">
                                  Softcover Photobook Album
                                </option>
                                <option value="Debossed Hardcover Photobook">
                                  Debossed Hardcover Photobook
                                </option>
                                <option value="Layflat Photobook Album">
                                  Layflat Photobook Album
                                </option>
                                <option value="Others">Others</option>
                                {/* Add other options here */}
                              </select>
                            )}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div class="form-group">
                          <label class="col-12 col-form-label">Size</label>
                          <div class="col-12 col-md-8">
                          {product.request_type === "frame" && (
                              <select
                                className="form-control"
                                value={product.frame_size}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    frame_size: e.target.value,
                                  })
                                }
                              >
                         
                         <option value="">--Select--</option>
                              <option value="A4 - 8.3 x 11.7 inches">A4 - 8.3 x 11.7 inches</option>
                              <option value="A5 - 5.8 x 8.3 inches">A5 - 5.8 x 8.3 inches</option>
                              <option value="10 X 10 inches">10 X 10 inches</option>
                              <option value="15 x 30 inches">15 x 30 inches</option>
                              {/* <option value="...">...</option> */}
                            </select>
                          )}
                           {product.request_type === "album" && (
                              <select
                                className="form-control"
                                value={product.album_size}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    album_size: e.target.value,
                                  })
                                }
                              >
                         
                         <option value="">--Select--</option>
                              <option value="11x14 inches - Landscape">
                                11x14 inches - Landscape
                              </option>
                              <option value="12x16 inches - Landscape">
                                12x16 inches - Landscape
                              </option>
                              <option value="11x8 inches - Portrait">
                                11x8 inches - Portrait
                              </option>
                              <option value="14x11 inches - Portrait">
                                14x11 inches - Portrait
                              </option>
                              {/* <option value="...">...</option> */}
                            </select>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Status
                          </label>
                          <div className="col-12 col-md-8">
                            <select
                              className="form-control"
                              value={product.status}
                              onChange={(e) =>
                                setProduct({
                                  ...product,
                                  status: e.target.value,
                                })
                              }
                            >
                              <option>--Select--</option>
                              <option value="not_started">Not Started</option>
                              <option value="in_progress">Inprogress</option>
                              <option value="completed">Completed</option>
                              {/* Add other options here */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.row */}

                    <div className="row mt-3">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="f_sz16 fwt_600">
                          Photos ({product.photo_list.length})
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      {product.photo_list.map((photo) => (
                        <div
                          key={photo._id}
                          className="col-6 col-sm-3 col-md-3 col-lg-2"
                        >
                          <div className="store_imgdiv mt-3">
                            <div className="storeimg">
                              <img
                                src={photo.file_url}
                                alt={photo.display_name}
                                border={0}
                              />
                            </div>
                            <div className="w-100 text-center">
                              {formatFileName(photo.display_name)}
                            </div>
                            {/* <div className="store_imgdel">
                              <i className="fa-solid fa-xmark" />
                            </div> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={handleUpdateProduct}
                    >
                      Update
                    </button>
                  </div>
                  {/* /.card-footer */}
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content */}
      </div>

      <Footer />
    </div>
  );
}

export default UserEdit;
